import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomInventoryDetailsComponent } from 'src/app/modules/custom-landing/custom-inventory-details/custom-inventory-details.component';
import InventoryManagementService from 'src/app/modules/custom-landing/inventory-unpublished-batch/inventory-management.service';
import { FormsModule } from '@angular/forms';
import { TwoDigitDecimaNumberDirective, CopyDirective } from '../two-digit-decima-number.directive';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-update-price-modal',
    templateUrl: './update-price-modal.component.html',
    styleUrls: ['./update-price-modal.component.scss'],
    imports: [FormsModule, TwoDigitDecimaNumberDirective, CopyDirective, NgIf]
})
export class UpdatePriceModalComponent implements OnInit {

  constructor(private toastService: ToastService,private router: Router,public ActiveModal: NgbActiveModal, private inventoryManagementService: InventoryManagementService) { }
  @Input() price: any;
  @Output() refresh: EventEmitter<any> = new EventEmitter();
  @Input() code: any;
  ngOnInit(): void {
  }

  checkPriceValidation($event){
    // tslint:disable-next-line:prefer-const
    let s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >= 6) {
        $event.preventDefault();
      }
    }
  }

  updatePrice(){
    const navigationData: NavigationExtras = {
      state: {
        data: localStorage.getItem("inventoryDetailsId")
      }
    }
    this.inventoryManagementService.updatePrice(this.code,this.price).subscribe(
      data => {
        if(data.status === "Price updated success"){
          this.toastService.showAndNavigate(data.status).subscribe(_=>this.refresh.emit())
        }
      }
    );
    this.ActiveModal.close('Update Price');
  }

}

